const LONDON_TIME_ZONE = 'Europe/London';
const ISO_TIME_ZONE_SUFFIX = /(?:[zZ]|[+-]\d{2}:\d{2})$/;

export function parseTimeEntryDate(value) {
  if (!value) {
    return null;
  }

  if (value instanceof Date) {
    return new Date(value.getTime());
  }

  if (typeof value === 'string') {
    return new Date(ISO_TIME_ZONE_SUFFIX.test(value) ? value : `${value}Z`);
  }

  return new Date(value);
}

export function formatTimeEntryDate(value, options = {}) {
  const date = parseTimeEntryDate(value);
  if (!date) {
    return '';
  }

  return date.toLocaleDateString('en-GB', {
    timeZone: LONDON_TIME_ZONE,
    ...options,
  });
}

export function formatTimeEntryTime(value) {
  const date = parseTimeEntryDate(value);
  if (!date) {
    return 'Active';
  }

  return date.toLocaleTimeString('en-GB', {
    timeZone: LONDON_TIME_ZONE,
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatTimeEntryDateTime(value, options = {}) {
  const date = parseTimeEntryDate(value);
  if (!date) {
    return '';
  }

  return date.toLocaleString('en-GB', {
    timeZone: LONDON_TIME_ZONE,
    ...options,
  });
}

export function getTimeEntryDayKey(value) {
  const date = parseTimeEntryDate(value);
  if (!date) {
    return '';
  }

  const formatter = new Intl.DateTimeFormat('en-CA', {
    timeZone: LONDON_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });

  return formatter.format(date);
}
